export type GrapeAPIErrorType = {
  status: number;
  message: string;
  errors: Array<string>;
  fieldErrors?: Record<string, string[]>;
  requestId?: string;
  // Custom field needed for QleStartErrorBanner. See app/api/web_api/member_onboarding/entities/qle_error.rb
  qleErrorCode?: string
}

export function GrapeAPIError ({
  status,
  message,
  errors,
  fieldErrors,
  requestId,
  qleErrorCode,
}: GrapeAPIErrorType) {
  return {
    status,
    message,
    errors,
    fieldErrors,
    requestId,
    qleErrorCode,
  }
}
